import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsItunesComponent } from './simple-icons-itunes.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsItunesComponent ],
    exports:      [ SimpleIconsItunesComponent ],
    bootstrap:    []
})
export class SimpleIconsItunesModule {}
